const getCSRFToken = () => {
  const csrfMeta = document.querySelector('meta[name="csrf-token"]');
  return csrfMeta ? csrfMeta.getAttribute('content') : '';
};

const buildHeaders = (body) => {
  const headers = {
    'X-CSRF-Token': getCSRFToken(),
    'X-Requested-With': 'XMLHttpRequest',
  };
  // FormData の場合は Content-Type を設定しない（ブラウザが自動設定）
  if (!(body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
    headers['Accept'] = 'application/json';
  } else {
    headers['Accept'] = 'application/json';
  }
  return headers;
};

class FetchError extends Error {
  constructor(response, data) {
    super(response.statusText);
    this.response = {
      data,
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
    };
    if (data && data.error) {
      this.error = data.error;
    }
  }
}

const request = async (url, options = {}) => {
  let response;
  try {
    response = await fetch(url, options);
  } catch (networkError) {
    // ネットワークエラー（オフライン、DNS解決失敗等）を FetchError でラップ
    throw new FetchError(
      { status: 0, statusText: networkError.message },
      { errors: [networkError.message] }
    );
  }

  const text = await response.text();
  let data;
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = text;
  }

  if (!response.ok) {
    throw new FetchError(response, data);
  }

  return {
    data,
    status: response.status,
    statusText: response.statusText,
    headers: response.headers,
  };
};

const client = {
  get: (url) =>
    request(url, {
      method: 'GET',
      headers: buildHeaders(),
    }),

  post: (url, body) =>
    request(url, {
      method: 'POST',
      headers: buildHeaders(body),
      body: body instanceof FormData ? body : JSON.stringify(body),
    }),

  patch: (url, body) =>
    request(url, {
      method: 'PATCH',
      headers: buildHeaders(body),
      body: body instanceof FormData ? body : JSON.stringify(body),
    }),

  put: (url, body) =>
    request(url, {
      method: 'PUT',
      headers: buildHeaders(body),
      body: body instanceof FormData ? body : JSON.stringify(body),
    }),

  delete: (url, body) =>
    request(url, {
      method: 'DELETE',
      headers: buildHeaders(body),
      body: body
        ? body instanceof FormData ? body : JSON.stringify(body)
        : undefined,
    }),
};

export default client;
